export const URGENCY_OPTIONS = [
  { value: 'none', label: 'Aciliyeti Yok', color: 'default' },
  { value: 'normal', label: 'Normal', color: 'blue' },
  { value: 'urgent', label: 'Acil', color: 'orange' },
  { value: 'critical', label: 'Kritik', color: 'red' },
];

export const urgencyMeta = (value) => URGENCY_OPTIONS.find((o) => o.value === value) || URGENCY_OPTIONS[0];
